
  import { Vue, Component, Prop, Watch } from "vue-property-decorator";
  import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";
  import ModalSectionsDivider from "@/components/modal/ModalSectionsDivider.vue";
  import UiButton from "@/components/button/ui-button.vue";
  import FormGroup from "@/components/form/FormGroup.vue";
  import FormTextarea from "@/components/form/FormTextarea.vue";
  import CardBodyItem from "@/components/card/CardBodyItem.vue";
  import ItemChipsWithMore from "@/components/common/ItemChipsWithMore.vue";
  import CollapsibleDescription from "@/components/common/CollapsibleDescription.vue";
  import ItemChipsData from "@/entities/ItemChipsData";
  import AttachDocument from "@/components/documents/AttachedDocument.vue";
  import AttachedDocument from "@/components/documents/AttachedDocument.vue";
  import DocumentMultiselect from "@/components/autocompleteMultiselects/DocumentMultiselect.vue";
  import { Document_Bool_Exp } from "@/generated/graphql";
  import UploadDocument from "@/components/documents/UploadDocument.vue";
  import { NOTIFICATION } from "@/entities/Events";
  import { defaultErrorNotificationMessage } from "@/data/errorMessages";
  import Message from '@/data/notificationsMessages';
  import getFormattedDuration from "@/helpers/getFormattedDuration";
import UploadIcon from "@/components/icons/UploadIcon.vue";
import UploadFileIcon from "@/components/icons/UploadFileIcon.vue";

  @Component({
    components: {
      UploadDocument,
      DocumentMultiselect,
      AttachedDocument,
      AttachDocument,
      CollapsibleDescription,
      ItemChipsWithMore,
      CardBodyItem,
      FormTextarea,
      FormGroup,
      UiButton,
      ModalSectionsDivider,
      ModalFullScreen,
      UploadIcon,
      UploadFileIcon
    },
  })
  export default class ApplicationNoteModal extends Vue {
    @Prop({ type: Array, required: true }) readonly skills!: ItemChipsData[];
    @Prop({ type: Array, required: true }) readonly industries!: ItemChipsData[];
    @Prop({ type: String, required: true }) readonly actionButtonText!: string;
    @Prop({ type: String, required: true }) readonly currentUserId!: string;
    @Prop({ type: String, required: true }) readonly applicationId!: string;
    @Prop({ type: String, required: true }) readonly postingId!: string;
    @Prop({ type: String, required: true }) readonly jobTitle!: string;
    @Prop({ type: String, required: true }) readonly companyName!: string;
    @Prop({ type: String, required: true }) readonly employmentType!: string;
    @Prop({ type: String, required: true }) readonly postedDate!: string;
    @Prop({ type: Number, default: 0 }) readonly duration!: number;
    @Prop({ type: String, required: undefined }) readonly location?: string;
    @Prop({ type: String, default: "" }) readonly description!: string;
    @Prop({ type: String, default: "" }) readonly note!: string;
    @Prop({ type: String, default: "Upload", required: false }) readonly attachButtonText!: string;
    @Prop({ type: String, default: undefined }) readonly attachedDocumentId?: string;
    @Prop({ type: Boolean, default: false }) readonly outerProcessing!: boolean;

    attachedDocumentIds: string[] = [];
    newFile: File | null = null;
    innerProcessing: boolean = false;

    get descriptionClasses(): Record<string, boolean> {
      return {
        ["mb-5"]: Boolean(!this.$scopedSlots.default),
      };
    }

    get postingDuration(): string | undefined {
      return getFormattedDuration(this.duration);
    }

    get processing(): boolean {
      return this.innerProcessing || this.outerProcessing;
    }

    get applicationTitle(): string {
      return `${this.jobTitle} - application`;
    }

    get documentMultiselectConditions(): Document_Bool_Exp {
      return {
        uploaded_by: {
          _eq: this.currentUserId,
        }
      };
    }

    @Watch("attachedDocumentId", { immediate: true })
    onAttachedDocumentIdChange() {
      if (this.attachedDocumentId) {
        this.attachedDocumentIds = [this.attachedDocumentId];
      }
    }

    attachNewFile(file: any) {
      this.newFile = file;
    }

    clearDocumentMultiselect(): void {
      this.attachedDocumentIds = [];
    }

    async update(uploadFile: () => Promise<void>): Promise<void> {
      if (this.processing) {
        return;
      }

      if (!this.newFile) {
        this.$emit('updated', this.attachedDocumentIds[0]);
        return;
      }

      this.innerProcessing = true;

      try {
        const fileData = await uploadFile();
        this.$emit('fileUploaded', fileData);
      } catch (_) {
        return this.$eventBus.emit(NOTIFICATION, Message.errorMessage(defaultErrorNotificationMessage));
      } finally {
        this.innerProcessing = false;
      }
    }
  }
